import { render } from "./checkbox-component.vue?vue&type=template&id=cbffe944&scoped=true"
import script from "./checkbox-component.vue?vue&type=script&lang=js"
export * from "./checkbox-component.vue?vue&type=script&lang=js"

import "./checkbox-component.vue?vue&type=style&index=0&id=cbffe944&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbffe944"]])

export default __exports__